import React, {useRef, useState, useEffect} from 'react'
import './removeEditCategory.css'
import firebase from '../../../../config/fbConfig'

const db = firebase.firestore(); 

function RemoveEditCategory(props) {
    const [categories, setCategories] = useState([]) // Holding all categories list
     
    // For removing categories
    const selectCategoryA = useRef() // A = Remove category

    // For edit category
    const [uploadChoiceCategory, setUploadChoiceCategory] = useState(0) // 0 Means the user didn't pick his way, 1 means by URL Link, 2 means by actually uploading
    const selectCategoryB = useRef() // B = Remove category
    const title = useRef() // Used to store the new name for a category
    const CategoryURL = useRef({tagName: null}) // Used to store the URL Link for category's pic

    useEffect(() => {
        updateCategory(props.menu);
    }, [])

    // Used to update the category on first render and after each remove
    let updateCategory = () => {
        // Getting all categories available and setting them in categories state
        let newArr = [];
        for (let i = 0; i < props.menu.length; i++) {
            newArr.push(props.menu[i].title);
        }
        setCategories(newArr);
    }

    let ExecuteRemove = (e, selectedIndex) => {
        e.preventDefault();

        if (window.location.href.includes('/en')) {
            if (selectedIndex === 0) {
                alert("You must select a category to remove.")
                return;
            }
        } else {
            if (selectedIndex === 0) {
                alert("עליך לבחור קטגוריה למחיקה.")
                return;
            }
        }
        
        selectedIndex--; // Because the 0's index is just "--SELECT--"
        let categoryName = props.menu[selectedIndex].title;
        if (window.location.href.includes('/en')) { 
            if (!window.confirm(`Are you sure you want to 𝗥𝗘𝗠𝗢𝗩𝗘 ${categoryName}? \nThis category contains ${props.menu[selectedIndex].products.length} items.`)) return;
        } else {
            if (!window.confirm(`האם אתה בטוח שברצונך למחוק את הקטגוריה ${categoryName}? \nהקטגוריה הזו מכילה ${props.menu[selectedIndex].products.length} מוצרים.`)) return;
        }
        
        
        props.menu.splice(selectedIndex, 1);
        
        let categoryLang = 'categories' + props.chosenLang;
        db.collection('menu').doc('categories').update({
            [categoryLang]: props.menu
        });
        
        let chosenCategory = categoryName.replace(/\s/g, ''); // To remove the spaces from chosen category to actually it valid name for folder in Firebase Storage
        
        // Removing the storage (all pics) from specific category
        // Need to get the whole list then iterate the items 1 by one
        firebase.storage().ref(chosenCategory).listAll().then(function(res) {
              res.items.forEach(function(itemRef) {
                // All the items under this category.
                itemRef.delete();
              });
        });

        if (window.location.href.includes('/he')) { 
            alert("Successfully removed!");
        } else {
            alert("נמחק בהצלחה!");
        }
        
        updateCategory();
        
    }
    
    // Used when the user wants to upload a local file for category's pic
    let uploadCategoryPic = (e, title) => {
        e.preventDefault();
        let fileCategory = document.getElementById('fileCategory');
        let file = fileCategory.files[0];
        let progressElem = document.getElementById('progressWrapperCategory').firstChild;

        if (window.location.href.includes('/en')) { 
            if (file==null) {
                alert(`You haven't uploaded any picture yet.`);
                return;
            }
    
            if (title==="") {
                alert("You must enter a category title before uploading.");
                return;
            }
    
            if (file.name.split('.').length!==2) {
                alert("You are not allowed to have . in your filename");
                return;
            }
        } else {
            if (file==null) {
                alert(`לא העלאת שום תמונה עדיין.`);
                return;
            }

            if (title==="") {
                alert("עליך להוסיף שם לקטגוריה.");
                return;
            }           
            
            if (file.name.split('.').length!==2) {
                alert("אסור שיהיה נקודה בשם קובץ התמונה, נא למחוק אותו ולנסות לעלות שוב");
                return;
            }
        }
       

        let chosenCategory = title.replace(/\s/g, ''); // To remove the spaces from chosen category to actually it valid name for folder in Firebase Storage
        
        if (file.type.match(/image/) && file.type !== 'image/svg+xml') {
            // Reset to default state before initial search
            progressElem.parentNode.style.display = 'block';
            progressElem.style.backgroundColor = '#21ba45';
            progressElem.style.width = '0%';
            progressElem.innerHTML = "";
            document.body.style.cursor = "wait";

            var reader = new FileReader();
            reader.readAsDataURL(file); 
            reader.onloadend = function() {
                var base64data = reader.result;
                const resizePic = firebase.functions().httpsCallable('resizePic');
                let newFilename = file.name.split('.')[0] + '.jpeg';
                
                resizePic({file: base64data, resize: 450})
                .then(res => {
                    let uploadTask = firebase.storage().ref(chosenCategory + '/' + newFilename).putString(res.data, 'base64', {contentType:'image/jpeg'});

                    uploadTask.on('state_changed', function(snapshot) {
                    let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    progressElem.style.width = progress + '%';
                    console.log('Upload is ' + progress + '% done');

                    if (progress == 100) {
                        let completed = document.createElement('p');
                        if (window.location.href.includes('/en')) { 
                            completed.innerHTML = "Success !";
                        } else {
                            completed.innerHTML = "הושלם !";
                        }
                        progressElem.appendChild(completed);
                    }
        
                    }, function(error) {
                        progressElem.style.backgroundColor = 'red';
                        progressElem.style.width = '100%';
                        document.body.style.cursor = "default";
                    }, function() {
                    // Handle successful uploads on complete
                    // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                    uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                        console.log('File available at', downloadURL);
                        CategoryURL.current = downloadURL;
                        document.body.style.cursor = "default";
                      });
                    });

                })
                .catch(err => {
                    if (window.location.href.includes('/en')) { 
                        alert("There's an error uploading this picture")
                      } else {
                        alert("שגיאה בהעלאת הקובץ");
                      }
                    console.log("There's an error", err);
                    progressElem.style.width = '100%';
                    progressElem.style.backgroundColor = 'red';
                    document.body.style.cursor = "default";
                });  
            }

        } else {
            if (window.location.href.includes('/en')) { 
                alert("The file you are trying to upload isn't a picture.");
              } else {
                alert("הקובץ שאתה מנסה לעלות הוא לא מסוג תמונה.");
              }  
        }
    }
    let UpdateValues = (selectedIndex) => {
        selectedIndex--;
        title.current.value = props.menu[selectedIndex].title;
        if (CategoryURL.current == null) CategoryURL.current = {tagName: null};
        if (CategoryURL.current.tagName==="INPUT") CategoryURL.current.value = props.menu[selectedIndex].CategoryURL;
    }
    let ExecuteEdit = (e, title, categoryIndex) => {
        e.preventDefault();

        if (window.location.href.includes('/en')) { 
            if (title === "") {
                alert("You must enter a title for the category.")
                return;
            }
            
            if (CategoryURL.current.tagName === null) {
                alert("You must upload a picture or enter URL.")
                return;
            }
        } else {
            if (title === "") {
                alert("עליך לבחור שם לקטגוריה.")
                return;
            }
            
            if (CategoryURL.current.tagName === null) {
                alert("עליך להעלות תמונה לקטגוריה.")
                return;
            }
        }
        
        
        categoryIndex--;
        if (title!==props.menu[categoryIndex].title) {
            if (window.location.href.includes('/en')) { 
                if (!window.confirm("Changing the category's title might lead to problems in Storage.\nAre you sure you want to continue?")) return;
            } else {
                if (!window.confirm("שינוי השם של הקטגוריה עלול להוביל לבעיות באחסון התמונות.\nהאם ברצונך להמשיך?")) return;
            }
        }
        
        props.menu[categoryIndex].title = title;
        props.menu[categoryIndex].CategoryURL = CategoryURL.current.tagName==="INPUT" ? CategoryURL.current.value : CategoryURL.current;

        let categoryName = 'categories' + props.chosenLang;
        db.collection('menu').doc('categories').update({
            [categoryName]: props.menu
        });

        if (window.location.href.includes('/en')) { 
            alert(`Successfully applied changes to ${title}`)
        } else {
            alert(`שינויים חלו בהצלחה לקטגוריית ${title}`)
        }
        
        updateCategory();
        
        document.getElementById('editCategory').reset();

        if (CategoryURL.current.tagName==="INPUT") {
            CategoryURL.current.value = "";
            setUploadChoiceCategory(0);
        } else {
            let progressElem = document.getElementById('progressWrapperCategory').firstChild;
            progressElem.parentNode.style.display = 'block';
            progressElem.style.backgroundColor = '#21ba45';
            progressElem.style.width = '0%';
            progressElem.innerHTML = "";
            setUploadChoiceCategory(0);
        }
        
    }
    
if (window.location.href.includes('/en')) { 
    return (
        <div id="removeEditCategory">
            <form id="removeCategory">
                <div className="middleWrapper">
                        <label>Select a category to remove</label>
                        <select defaultValue={"nothing"} ref={selectCategoryA}>
                            <option disabled value="nothing">-- SELECT --</option>
                            {categories.map((value) => 
                                <option value={value} key={value}>{value}</option>
                            )}
                        </select>
                        <button id="mainButton" onClick={(e) => ExecuteRemove(window.event, selectCategoryA.current.selectedIndex)}>REMOVE</button>
                </div>
            </form>

            <hr/>

            
            <div className="titleComponent">Select a category to edit</div>
            <form id="editCategory" className="middleWrapper" style={{marginTop: '100px'}}>
                    <label>Select a category</label>
                    <select defaultValue={"nothing"} ref={selectCategoryB} onChange={() => UpdateValues(selectCategoryB.current.selectedIndex)}>
                        <option disabled value="nothing">-- SELECT --</option>
                        {categories.map((value) => 
                            <option value={value} key={value}>{value}</option>
                        )}
                    </select>

                    <div id="inFlexWrapper">
                        <div>
                            <label>Category's title</label>
                            <input type="text" ref={title}/>
                        </div>
                        
                        <div>
                        {uploadChoiceCategory==0 &&
                        <React.Fragment>
                            <label>Upload a Picture</label>
                            <div className="fileWrapper" style={{border: '1px solid gray', backgroundColor: 'white'}}>
                            <button style={{left: '0', borderBottomRightRadius: '15px', borderTopRightRadius: '15px', borderBottomLeftRadius: '0', borderTopLeftRadius: '0'}} onClick={() => setUploadChoiceCategory(1)}>URL Link</button>
                            <button onClick={() => setUploadChoiceCategory(2)}>Upload Local File</button>
                            </div>
                        </React.Fragment>
                        }

                        {uploadChoiceCategory==1 &&
                        <React.Fragment>
                            <label>Upload a Picture (URL Link)</label>
                            <input type="text" ref={CategoryURL} defaultValue={selectCategoryB.current.selectedIndex > 0 ? props.menu[selectCategoryB.current.selectedIndex-1].CategoryURL : ""}/>
                        </React.Fragment>
                        }

                        {uploadChoiceCategory==2 &&
                        <React.Fragment>
                            <label>Upload a Picture (Local File)</label>
                            <div className="fileWrapper">
                                <input type="file" id="fileCategory" className="relativeInput"/>
                                <button onClick={() => uploadCategoryPic(window.event, title.current.value)} style={{width: '85px'}}><span>UPLOAD</span></button>
                            </div>
                            <div id="progressWrapperCategory" style={{display: 'none'}}>
                                <div></div>
                            </div>
                        </React.Fragment>
                        }
                        </div>

                    </div>

                    <button id="mainButton" onClick={(e) => ExecuteEdit(window.event, title.current.value, selectCategoryB.current.selectedIndex)}>Apply Changes</button>
            
            </form>
        </div>  
    )
}

    return (
        <div id="removeEditCategory">
            <form id="removeCategory">
                <div className="middleWrapper">
                        <label>בחר קטגוריה שברצונך למחוק</label>
                        <select defaultValue={"nothing"} ref={selectCategoryA}>
                            <option disabled value="nothing">-- קטגוריה --</option>
                            {categories.map((value) => 
                                <option value={value} key={value}>{value}</option>
                            )}
                        </select>
                        <button id="mainButton" onClick={(e) => ExecuteRemove(window.event, selectCategoryA.current.selectedIndex)}>מחק</button>
                </div>
            </form>

            <hr/>

            
            <div className="titleComponent">עריכת קטגוריה</div>
            <form id="editCategory" className="middleWrapper" style={{marginTop: '100px'}}>
                    <label>בחר קטגוריה שברצונך לערוך</label>
                    <select defaultValue={"nothing"} ref={selectCategoryB} onChange={() => UpdateValues(selectCategoryB.current.selectedIndex)}>
                        <option disabled value="nothing">-- קטגוריה --</option>
                        {categories.map((value) => 
                            <option value={value} key={value}>{value}</option>
                        )}
                    </select>

                    <div id="inFlexWrapper">
                        <div>
                            <label>שם הקטגוריה</label>
                            <input type="text" ref={title}/>
                        </div>
                        
                        <div>
                        {uploadChoiceCategory==0 &&
                        <React.Fragment>
                            <label>העלאת תמונה</label>
                            <div className="fileWrapper" style={{border: '1px solid gray', backgroundColor: 'white'}}>
                            <button style={{left: '0', borderBottomRightRadius: '15px', borderTopRightRadius: '15px', borderBottomLeftRadius: '0', borderTopLeftRadius: '0'}} onClick={() => setUploadChoiceCategory(1)}>URL לינק</button>
                            <button onClick={() => setUploadChoiceCategory(2)}>העלה קובץ מקומי</button>
                            </div>
                        </React.Fragment>
                        }

                        {uploadChoiceCategory==1 &&
                        <React.Fragment>
                            <label>העלאת תמונה (URL לינק)</label>
                            <input type="text" ref={CategoryURL} defaultValue={selectCategoryB.current.selectedIndex > 0 ? props.menu[selectCategoryB.current.selectedIndex-1].CategoryURL : ""}/>
                        </React.Fragment>
                        }

                        {uploadChoiceCategory==2 &&
                        <React.Fragment>
                            <label>העלאת תמונה (קובץ מקומי)</label>
                            <div className="fileWrapper">
                                <input type="file" id="fileCategory" className="relativeInput"/>
                                <button onClick={() => uploadCategoryPic(window.event, title.current.value)} style={{width: '85px'}}><span>העלאה</span></button>
                            </div>
                            <div id="progressWrapperCategory" style={{display: 'none'}}>
                                <div></div>
                            </div>
                        </React.Fragment>
                        }
                        </div>

                    </div>

                    <button id="mainButton" onClick={(e) => ExecuteEdit(window.event, title.current.value, selectCategoryB.current.selectedIndex)}>שמור שינויים</button>
               
            </form>
        </div>
    )
}

export default RemoveEditCategory
